import { CloudUpload } from '@mui/icons-material';
import { Box, Button, Grid, LinearProgress, Typography } from '@mui/material';
import React from 'react';

import { VisuallyHiddenInput } from '@/theme/styled-components';

interface AttachmentsListHeaderProps {
  accept: string;
  isUploading: boolean;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AttachmentsListHeader: React.FC<AttachmentsListHeaderProps> = ({ accept, isUploading, onFileSelect }) => (
  <Grid container justifyContent="space-between" alignItems="center">
    <Typography variant="h6" gutterBottom>
      Documents
    </Typography>
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" my={1}>
      <Button component="label" variant="contained" size="small" startIcon={<CloudUpload />} disabled={isUploading}>
        Upload files
        <VisuallyHiddenInput type="file" accept={accept} multiple onChange={onFileSelect} />
      </Button>
      {isUploading && (
        <Box display="flex" alignItems="center" gap={1} flex={1} minWidth={120}>
          <LinearProgress sx={{ flex: 1, height: 6, borderRadius: 1 }} variant="indeterminate" />
          <Typography variant="caption" color="text.secondary">
            Uploading…
          </Typography>
        </Box>
      )}
    </Box>
  </Grid>
);

export default AttachmentsListHeader;
